module.exports = __webpack_public_path__ + "static/media/arrow-down-import-dark.46e4f9ea.svg";